import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import { getEquipmentDetails, postApproval } from "../Actions/ApproverScreenAPI";
import { getAllShipPortAndCountry, } from "../Actions/ServiceProviderAPI";
import $ from "jquery";


let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let userrole = localStorage.getItem("UserRoles");

class EquipmentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      serviceImages: [],
      putData: [],
      remarks: "",
      isApproved: false,
      openAlert: false,
      attachmentFile: [],
    };

  }

  componentDidMount() {
    const { dispatch, match, EquipmentDetails, isLoaded, EquipmentData } = this.props;
    const { params } = match;
    const { itemId } = params;
    dispatch(getEquipmentDetails(itemId));
    dispatch({ type: "ShowSidePan", data: true });
    dispatch({ type: "SubBannerTitle", data: "Ship Equipments List" });
    dispatch(getAllShipPortAndCountry());
    if (EquipmentData?.equipmentName) {
      if (EquipmentData.equipmentName.toLowerCase().includes("lifeboat")) {
        $("#ModelHide").addClass("none");
        $("#MakeHide").addClass("none");
        $("#LifeBoatEquipment").removeClass("lifeBoat-hide");
        $("#LifeBoatEquipment1").removeClass("lifeBoat-hide");
        $("#LifeBoatEquipment2").removeClass("lifeBoat-hide");
        $("#LifeBoatEquipment3").removeClass("lifeBoat-hide");
        $("#categoryequiptype").addClass("categorylifeboat");
      } else if (EquipmentData.equipmentName.toLowerCase().includes("rescue boat")) {
        $("#ModelHide").addClass("none");
        $("#MakeHide").addClass("none");
        $("#categoryequiptype").removeClass("categorylifeboat");
        $("#rescueboatEquipment").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment1").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment2").removeClass("lifeBoat-hide");
        $("#rescueboatEquipment3").removeClass("lifeBoat-hide");
      } else {
        $("#ModelHide").removeClass("none");
        $("#MakeHide").removeClass("none");
        $("#LifeBoatEquipment").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment1").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment2").addClass("lifeBoat-hide");
        $("#LifeBoatEquipment3").addClass("lifeBoat-hide");
        $("#rescueboatEquipment").addClass("lifeBoat-hide");
        $("#rescueboatEquipment1").addClass("lifeBoat-hide");
        $("#rescueboatEquipment2").addClass("lifeBoat-hide");
        $("#rescueboatEquipment3").addClass("lifeBoat-hide");
      }
    }
  }

  handleInputChange(e) {
    let _remarks = "";
    if (e.target.value !== "") {
      _remarks = e.target.value;
      $("#remark").css("border-color", "#e0e0e0");
      this.setState({ isApproved: true });
    } else {
      this.setState({
        remarks: "",
        isApproved: false
      });
    }
    this.setState({ remarks: _remarks });
  }

  hideSidePanel = () => {
    const { dispatch, history, match } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch({ type: "ShowSidePan", data: false });
    history.push(`/Home/PendingApprovals/${id}/Equipments`);
  };

  SubmitAction(action) {
    
    const { dispatch, history, EquipmentDetails, t } = this.props
    const { remarks, isApproved } = this.state;
    if (remarks === "") {
      $("#remark").css("border-color", "red");
    }
    else {
      this.setState({ isApproved: true })
    }
    if (isApproved) {
      if (action === 1) {
        let pushdata = [];
        EquipmentDetails.map((item, index) => {
          let data = {};
          data.shipId = item.shipId;
          data.equipmentId = item.equipmentId;
          data.equipmentServiceId = item.equipmentServiceId;
          data.isValid = true;
          data.validatedBy = currentuser.email;
          data.remarks = this.state.remarks;
          data.isAdmin = userrole === "admin" ? true : false;
          pushdata.push(data);
        })
        this.setState({}, () => {
          dispatch(postApproval(pushdata, history, t))
        })
      }
      else if (action === 2) {
        let pushdata = [];
        EquipmentDetails.map((item, index) => {
          let data = {};
          data.shipId = item.shipId;
          data.equipmentId = item.equipmentId;
          data.equipmentServiceId = item.equipmentServiceId;
          data.isValid = false;
          data.validatedBy = currentuser.email;
          data.remarks = this.state.remarks;
          data.isAdmin = userrole === "admin" ? true : false;
          pushdata.push(data);
        })
        this.setState({}, () => {
          dispatch(postApproval(pushdata, history, t))
        })
      }
    }
  }

  render() {
    const { openAlert } = this.state;
    const { EquipmentDetails, EquipmentList, match, Yearly1, Yearly2, Yearly3, Yearly5, Yearly10, t } = this.props;
    const { itemId } = match.params;
    return (
      <div className="d-flex col-sm-12 col-md-6 col-lg-6 mobile">
        <div className="full-height">
          <div className="row" style={{ paddingTop: "25px" }}>
            <div className="col-lg-12 mr-3">
              <div className="panel-box search-filter-box">
                <button
                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                  onClick={() => this.hideSidePanel()}
                >
                  &larr; {t("CommonText.Return")}
                </button>
                {EquipmentList && EquipmentList.map((item, index) => {
                  if (`${item.shipEquipmentId}` === itemId) {
                    return (
                      <>
                        <div className="row">
                          <div className="col-lg-12">
                            <div
                              className="card mt-2 MM-card-header"
                              style={{ backgroundColor: "white" }}
                            >
                              <div
                                className="card-body"
                                style={{
                                  padding: "0rem",
                                  backgroundColor: "#1a3464",
                                  color: "white",
                                }}
                              >
                                <h5
                                  className="card-title ml-2 mt-2"
                                  style={{ color: "092a51" }}
                                >
                                  {t("ShipDetailsScreen.EquipmentDetails")}
                                </h5>
                              </div>
                            </div>
                            <div className="row pt-2 pb-4 search-filter-box">
                              <div className="col-lg-6">
                                <label className="form-label">{t("ShipEquipmentStatusScreen.EquipmentName")}</label>
                                <br></br>
                                <select
                                  className="form-control"
                                  name="equipment"
                                  value={item.equipmentName}
                                  disabled={true}
                                >
                                  <option value="">{item.equipmentName}</option>
                                </select>
                              </div>
                              <div className="col-lg-6">
                                <label className="form-label">{t("CategoryScreen.Title")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="category"
                                  placeholder={t("CategoryScreen.Title")}
                                  value={item.category}
                                  disabled={true}
                                ></input>
                              </div>
                              <div className="col-lg-6">
                                <label className="form-label"> {t("ComplianceandBudgetScreen.Type")}</label>
                                <br></br>
                                <select
                                  className="form-control"
                                  name="equipmentType"
                                  value={item.equipmentType}
                                  disabled={true}
                                >
                                  <option value="">{item.equipmentType}</option>
                                </select>
                              </div>
                              <div className="col-lg-6">
                                <label className="form-label">{t("ShipEquipmentStatusScreen.Capacity")} </label>
                                <br></br>
                                <select
                                  className="form-control"
                                  name="capacity"
                                  value={item.capacity}
                                  disabled={true}
                                ><option value="">{item.capacity}</option>
                                </select>
                              </div>
                              <div className="col-lg-6">
                                <label className="form-label">{t("ShipEquipmentStatusScreen.ManufacturingDate")}</label>
                                <br></br>
                                <div
                                  className="input-group add-on date datepicker"
                                  data-date-format="yyyy-mm-dd"
                                >
                                  <input
                                    type="text"
                                    className="form-control date-picker"
                                    placeholder={t("ShipEquipmentStatusScreen.ManufacturingDate")}
                                    value={item.manufacturingDate ? moment(item.manufacturingDate).format("YYYY-MM-DD") : ""}
                                    disabled={true}
                                  ></input>
                                  <DatePicker
                                    showMonthDropdown
                                    showYearDropdown
                                    onChange={this.handleManufacturingDate}
                                    open={this.state.DatePickerIsOpen}
                                    onClickOutside={this.handleBlur}
                                    disabled={true}
                                    dropdownMode="select"
                                    popperPlacement="top-end"
                                    className="form-control date-picker w-5 hide-date"
                                  />
                                </div>
                              </div>
                              <div id="LifeBoatEquipment" className="col-lg-6 lifeBoat-hide">
                                <label className="form-label">{t("EditEquipmentScreenContent.LifeboatMake")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="make"
                                  placeholder={t("EditEquipmentScreenContent.LifeboatMake")}
                                  value={item.lifeboatMake}
                                  disabled={true}
                                ></input>
                              </div>
                              <div id="LifeBoatEquipment1" className="col-lg-6 lifeBoat-hide">
                                <label className="form-label">{t("EditEquipmentScreenContent.Davit/winchMake")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="model"
                                  placeholder={t("EditEquipmentScreenContent.Davit/winchMake")}
                                  value={item.davitWinchMake}
                                  disabled={true}
                                ></input>
                              </div>
                              <div id="LifeBoatEquipment3" className="col-lg-6 lifeBoat-hide">
                                <label className="form-label">{t("EditEquipmentScreenContent.LifeboatModel")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="make"
                                  placeholder={t("EditEquipmentScreenContent.LifeboatModel")}
                                  value={item.lifeboatModel}
                                  disabled={true}
                                ></input>
                              </div>
                              <div id="LifeBoatEquipment2" className="col-lg-6 lifeBoat-hide">
                                <label className="form-label">{t("EditEquipmentScreenContent.LifeboatRelease")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="model"
                                  placeholder={t("EditEquipmentScreenContent.LifeboatRelease")}
                                  value={item.lifeboatRelease}
                                  disabled={true}
                                ></input>
                              </div>
                              <div id="rescueboatEquipment" className="col-lg-6 lifeBoat-hide">
                                <label className="form-label">{t("EditEquipmentScreenContent.rescueboatMake")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="make"
                                  placeholder={t("EditEquipmentScreenContent.rescueboatMake")}
                                  value={item.rescueboatMake}
                                  disabled={true}
                                ></input>
                              </div>
                              <div id="rescueboatEquipment1" className="col-lg-6 lifeBoat-hide">
                                <label className="form-label">{t("EditEquipmentScreenContent.rescueboatDavit/winchMake")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="model"
                                  placeholder={t("EditEquipmentScreenContent.rescueboatDavit/winchMake")}
                                  value={item.rescueboatdavitMake}
                                  disabled={true}
                                ></input>
                              </div>
                              <div id="rescueboatEquipment3" className="col-lg-6 lifeBoat-hide">
                                <label className="form-label">{t("EditEquipmentScreenContent.rescueboatModel")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="make"
                                  placeholder={t("EditEquipmentScreenContent.rescueboatModel")}
                                  value={item.rescueboatModel}
                                  disabled={true}
                                ></input>
                              </div>
                              <div id="rescueboatEquipment2" className="col-lg-6 lifeBoat-hide">
                                <label className="form-label">{t("EditEquipmentScreenContent.rescueboatRelease")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="model"
                                  placeholder={t("EditEquipmentScreenContent.rescueboatRelease")}
                                  value={item.rescueboatRelease}
                                  disabled={true}
                                ></input>
                              </div>
                              <div className="col-lg-6" id="MakeHide">
                                <label className="form-label">{t("ShipEquipmentStatusScreen.Make")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="make"
                                  placeholder={t("ShipEquipmentStatusScreen.Make")}
                                  value={item.make}
                                  disabled={true}
                                ></input>
                              </div>
                              <div className="col-lg-6" id="ModelHide">
                                <label className="form-label">{t("ShipEquipmentStatusScreen.Model")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="model"
                                  placeholder={t("ShipEquipmentStatusScreen.Model")}
                                  value={item.model}
                                  disabled={true}
                                ></input>
                              </div>
                              <div className="col-lg-6" >
                                <label className="form-label" id="categoryequiptype">{t("ShipEquipmentStatusScreen.Quantity")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="quantity"
                                  placeholder={t("ShipEquipmentStatusScreen.Quantity")}
                                  value={item.quantity}
                                  disabled={true}
                                ></input>
                              </div>
                              <div className="col-lg-6" >
                                <label className="form-label"> {t("ShipEquipmentStatusScreen.Unit-Quantity")}</label>
                                <br></br>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="unit"
                                  placeholder={t("ShipEquipmentStatusScreen.Unit-Quantity")}
                                  value={item.unit}
                                  disabled={true}
                                ></input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  }
                })}


                <div className="row">
                  <div className="col-lg-12">
                    <div
                      className="card mt-2 MM-card-header"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2"
                          style={{ color: "092a51" }}
                        >
                          {t("PendingApprovalScreenContent.ServiceDetails")}
                        </h5>
                      </div>
                    </div>

                    {EquipmentDetails && EquipmentDetails.map((item, index) => {
                      return (
                        <>
                          <div>
                            <div className="row  pt-2 search-filter-box form-group">
                              <div className="col-lg-6">
                                <label className="form-label">
                                  {t("ServiceDetails.Last")} {item.serviceType} {t("ServiceDetails.ServiceDone")}
                                </label>
                                <br></br>
                                <div
                                  className="input-group add-on date datepicker"
                                  data-date-format="yyyy-mm-dd"
                                >
                                  <input
                                    type="text"
                                    className="form-control date-picker"
                                    placeholder={`${t("ServiceDetails.Last")} 1 yearly ${t("ServiceDetails.ServiceDone")}`}
                                    value={item.serviceDate ? moment(item.serviceDate).format("YYYY-MM-DD") : ""}
                                    disabled={true}
                                  ></input>
                                  <DatePicker
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    popperPlacement="top-end"
                                    className="form-control date-picker w-5 hide-date"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <label className="form-label">
                                  {t("ServiceDetails.Next")} {item.serviceType} {t("ServiceDetails.ServiceDue")}
                                </label>
                                <br></br>
                                <div
                                  className="input-group add-on date datepicker"
                                  data-date-format="yyyy-mm-dd"
                                >
                                  <input
                                    type="text"
                                    className="form-control date-picker"
                                    value={item.nextDueIn ? moment(item.nextDueIn).format("YYYY-MM-DD") : ""}
                                    disabled={true}
                                  ></input>
                                  <DatePicker
                                    showMonthDropdown
                                    showYearDropdown
                                    popperPlacement="top-end"
                                    dropdownMode="select"
                                    className="form-control date-picker w-5 hide-date"
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div
                                  className="autocomplete-wrappers"
                                  style={{ zIndex: openAlert ? 99 : 9999 }}
                                >
                                  <label className="form-label">
                                    {t("ServiceDetails.Last")} {item.serviceType} {t("ServiceDetails.ServicePort")}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="port"
                                    placeholder="Port"
                                    value={item.lastDonePort}
                                    disabled={true}
                                  ></input>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div
                                  className="autocomplete-wrappers"
                                  style={{ zIndex: openAlert ? 99 : 9999 }}
                                >
                                  <label className="form-label">
                                    {t("ServiceDetails.Last")} {item.serviceType} {t("ServiceDetails.ServiceCountry")}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="country"
                                    placeholder={`${t("EquipmentServiceTypes.Country")}`}
                                    value={item.lastDoneCountry}
                                    disabled={true}
                                  ></input>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div
                                  className="autocomplete-wrappers"
                                  style={{ zIndex: openAlert ? 99 : 999 }}
                                >
                                  <label className="form-label">
                                    {t("ServiceDetails.Last")} {item.serviceType} {t("ServiceDetails.ServiceProvider")}
                                  </label>
                                  <br></br>
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="Serviceprovider"
                                    placeholder="Service provider"
                                    value={item.lastDoneServiceProvider}
                                    disabled={true}
                                  ></input>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <label className="form-label">
                                  {item.serviceType} Service Type
                                </label>
                                <br></br>
                                <span>
                                  {item?.isShip ? "Ship" : ""} {" "}{" "}
                                  {item?.isShore ? "Shore" : ""}
                                </span>
                              </div>
                              <div className="col-lg-12 pb-0">
                                <label className="form-label">
                                  {t("ServiceDetails.Last")} {item.serviceType}{t("ServiceDetails.ServiceCertificate")}{" "}
                                </label>
                                {item.attachmentName !== null ?

                                  <div className="row">
                                    <div className="col-lg-10">
                                      <p className="mb-0 text-break">{item.attachmentName}
                                      </p></div>
                                    <div className={"col-sm-2 col-md-2 col-2 col-lg-2 m-auto"}>
                                      <div className="text-right" style={{ marginLeft: "-5px", marginTop: "-7px" }}>
                                        <a href={item.fileUrl} target="blank">
                                          <i
                                            className="fa fa-eye click px-1 m-1 mr-3"
                                            aria-hidden="true"
                                            style={{ color: " #1a3464", fontSize: "1.75rem" }}
                                          ></i>
                                        </a>
                                      </div>
                                    </div>
                                  </div>

                                  : <></>}
                              </div>

                              <div className="col-lg-12 hide-pic-option">
                                <label className="form-label">
                                  {t("ServiceDetails.Last")} {item.serviceType} {t("ServiceDetails.ServicePhotos")}{" "}
                                </label>
                                <br></br>
                                {item.serviceType === "1 yearly" ?
                                  Yearly1 && Yearly1.map((ele, index) => {
                                    return (
                                      <>
                                        <a href={ele.fileLink} target="blank" className="text-break">{ele.fileName}</a>
                                        <br></br>
                                      </>
                                    )
                                  }) :
                                  <></>}
                                {item.serviceType === "2 yearly" ?
                                  Yearly2 && Yearly2.map((ele, index) => {
                                    return (
                                      <>
                                        <a href={ele.fileLink} target="blank" className="text-break">{ele.fileName}</a>
                                        <br></br>
                                      </>
                                    )
                                  }) :
                                  <></>}
                                {item.serviceType === "3 yearly" ?
                                  Yearly3 && Yearly3.map((ele, index) => {
                                    return (
                                      <>
                                        <a href={ele.fileLink} target="blank" className="text-break">{ele.fileName}</a>
                                        <br></br>
                                      </>
                                    )
                                  }) :
                                  <></>}
                                {item.serviceType === "5 yearly" ?
                                  Yearly5 && Yearly5.map((ele, index) => {
                                    return (
                                      <>
                                        <a href={ele.fileLink} target="blank" className="text-break">{ele.fileName}</a>
                                        <br></br>
                                      </>
                                    )
                                  }) :
                                  <></>}
                                {item.serviceType === "10 yearly" ?
                                  Yearly10 && Yearly10.map((ele, index) => {
                                    return (
                                      <>
                                        <a href={ele.fileLink} target="blank" className="text-break">{ele.fileName}</a>
                                        <br></br>
                                      </>
                                    )
                                  }) :
                                  <></>}
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    })}
                    <div className="row search-filter-box form-group pt-0">
                      <div className="col-lg-12">
                        <label className="form-label  required">
                          {t("DashboardShipReports.Remarks")}{" "}
                        </label>
                        <textarea
                          style={{ height: "10vh" }}
                          className="form-control"
                          type="text"
                          name="Remarks"
                          id="remark"
                          value={this.state.remarks}
                          onChange={(e) => this.handleInputChange(e)}
                          required
                        ></textarea>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="row pt-2 search-filter-box form-group">
                  <div className="col-lg-12 pl-3 pr-3 pb-3">
                    <div
                      className=" search-btn-col"
                      style={{ textAlign: "end" }}
                    >
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit"
                        onClick={() => this.SubmitAction(1)}
                      >
                        {" "}
                        {t("ComplianceandBudgetScreen.Approve")}{" "}
                      </button>
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-3"
                        type="button"
                        onClick={() => this.SubmitAction(2)}
                      >
                        {" "}
                        {t("ComplianceandBudgetScreen.Reject")}{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    EquipmentList: state.ApproverScreenReducer.ApprovalDetails || [],
    showSidePane: state.SidePanReducer.sidePan || false,
    EquipmentDetails: state.ApproverScreenReducer.EquipmentDetails || [],
    Yearly1: state.ApproverScreenReducer.Yearly1 || [],
    Yearly2: state.ApproverScreenReducer.Yearly2 || [],
    Yearly3: state.ApproverScreenReducer.Yearly3 || [],
    Yearly5: state.ApproverScreenReducer.Yearly5 || [],
    Yearly10: state.ApproverScreenReducer.Yearly10 || [],
    EquipmentData: state.ApproverScreenReducer.EquipmentData || [],
    EquipmentNameListAndId: state.MasterScreenReducer.EquipmentNameListAndId || [],
    fileUrl: state.ApproverScreenReducer.fileUrl || null,
    isLoaded: state.ApproverScreenReducer.isLoaded || false,
    // PortListAll: state.MasterScreenReducer.ShipPortListAll || [],
    // CountryListAll: state.MasterScreenReducer.ShipCountryListAll || [],
    // ServiceProviderPortListAll: state.MasterScreenReducer.ShipServiceProviderPortListAll || [],
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentDetails)));
